<template>
  <c-page>
    <div class="top-item">
      <div class="m-border-bottom panel-item">
        <div class="item-icon"><img :src="panelItemInfo.itemIcon" alt=""></div>
        <div class="item-intro">
          <div class="product-price">{{defaultPrice| currency0}}</div>
          <div class="text-two-line product-desc">{{panelItemInfo.desc}}{{selectedItem}}</div>
        </div>
      </div>
    </div>
    <c-content>
      <div class="action-modal">
        <div class="combo-panel">
          <div class="m-border-bottom combo-body combo-one">
            <div class="combo-item">
              <!-- <div class="combo-single">
                <div class="combo-single-title">店务管理</div>
                <div class="combo-single-checked">行业版一年</div>
              </div> -->
              <div class="combo-single">
                <div class="combo-single-title">移动支付</div>
                <div class="combo-single-checked">费率低至0.3%</div>
              </div>
            </div>
            <div class="combo-single">
              <div class="combo-single-title">整合营销</div>
              <div class="combo-single-checked lg-checked"><span>微信营销·至尊版一年 </span> | <span>小程序一年</span></div>
               <div class="combo-single-checked lg-checked mr-top"><span>包含5000条营销短信包</span></div>
            </div>
            <div class="combo-single" style="width:100%">
              <div class="combo-single-title">行业版本一年(请选择)</div>
              <div class="choose-box">
                <span @click="chooseVersion(247)" :class="versionId === 247 ? 'version-check' : ''">通用零售</span>
                <span @click="chooseVersion(243)" :class="versionId === 243 ? 'version-check' : ''">服装鞋帽</span>
                <span @click="chooseVersion(245)" :class="versionId === 245 ? 'version-check' : ''">母婴亲子</span>
                <span @click="chooseVersion(255)" :class="versionId === 255 ? 'version-check' : ''">宠物</span>
                <span @click="chooseVersion(244)" :class="versionId === 244 ? 'version-check' : ''">美业丽人</span>
                <span @click="chooseVersion(246)" :class="versionId === 246 ? 'version-check' : ''">数码电子</span>
                <span @click="chooseVersion(258)" :class="versionId === 258 ? 'version-check' : ''">眼镜</span>
                <span @click="chooseVersion(242)" :class="versionId === 242 ? 'version-check' : ''">餐饮</span>
              </div>
            </div>
          </div>
          <div class="combo-body combo-two">
            <!-- <div class="combo-single-title">开店硬件（还有相应耗材赠送 ）</div> -->
            <div class="combo-item">
              <div class="combo-item-inline" v-for="item in productItem" @click="selectedChange(item)">
                <div class="item-list" :class="[item.checked ? 'single-checked' : '']">
                  <img :src="item.imgSrc" alt="">
                  <div class="hardware-name">{{item.name}}</div>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="combo-body combo-three">-->
            <!--<div class="combo-single-title">超值换购（可多选）</div>-->
            <!--<div class="combo-item">-->
              <!--<div v-for="item in redemptionObj" class="redemption-single" :class="[item.checked ? 'single-checked' : '']" @click="redemptionSelect(item)">-->
                <!--<span class="redemption-price">{{item.price}}</span>-->
                <!--<span class="split-line"> | </span>-->
                <!--<span class="redemption-desc">{{item.desc}}</span>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        </div>
      </div>
    </c-content>
    <c-footer>
      <c-button @click.native="orderConfirm" :class="versionId === 0 ? 'no-checked' : ''">确认</c-button>
    </c-footer>
  </c-page>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<style>
  .s-actionsheet .weui-actionsheet {
    background-color: transparent !important;
  }
  
  .action-wrap .weui-actionsheet, .weui-actionsheet__menu, .c-page {
    border-radius: 10px 10px 0 0;
  }
</style>
<script>
  import ItemData from '../../../../../model/laoban'
  import debounce from 'lodash.debounce'
  import VasObj from '../../../../../model/value-added-service/index'
  import Tickets from '../../../../../model/tickets/index'

  export default {
    data () {
      const itemData = new ItemData()
      return {
        itemData,
        vasObj: new VasObj(),
        productItem: [],
        panelItemInfo: {
          itemIcon: 'https://res.laoban100.com/app-comm/assets/images/mallview/FiuQU-bEfKz3KwHFHQb2yvuEAN4U.png',
          price: 0,
          desc: '已选：行业版一年 费率0.3% 微信至尊版一年 小程序一年'
        },
        checked: false,
        redemptionObj: [{
          type: 'message',
          price: '¥ 1',
          desc: '可得518条短信',
          checked: false,
          money: 1,
          name: '加1元可得518条短信'
        }, {
          type: 'prolong',
          price: '¥ 518',
          desc: '所有软件服务延长一年',
          checked: false,
          money: 158,
          name: '加158元所有软件服务延长一年'
        }],
        nullHardware: 0,
        redemptionGroup: {
          nullRedemption: 137,
          prolong: 138,
          addMessage: 139,
          bothSelected: 140
        },
        goodsId: 0,
        selecedObj: {
          goodsId: '',
          remark: ''
        },
        selectedItemObj: [],
        goodsInfo: {},
        selectCount: 1,
        remarkId: 0,
        versionId: 0,
        defaultPrice: 2388
      }
    },
    components: {},
    created () {
    },
    async mounted () {
      await this.getImage()
      this.initGetInfo()
      this.getDetail()
    },
    beforeDestroy () {
    },
    methods: {
      closeActionSheet () {
      },
      async getImage () {
        let data = await this.itemData.getRealImage()
        this.productItem = data.productItem
      },
      chooseVersion (id) {
        this.versionId = id
      },
      selectedChange (item) {
        if (!item.checked) {
          this.productItem.map(cItem => {
            cItem.checked = false
          })
        }
        item.checked = !item.checked
        if (item.checked) {
          this.remarkId = item.remark
        } else {
          this.remarkId = this.nullHardware
        }
        this.initGetInfo()
      },
      redemptionSelect (item) {
        item.checked = !item.checked
        this.initGetInfo()
      },
      initGetInfo () {
        this.itemData.getUserInfo(this.redemptionGroupId, this.remarkId).then(res => {
          this.panelItemInfo.price = res.RealMoney
          this.panelItemInfo.CouponList = (res.CouponList || {}).CouponListModels || []
          this.panelItemInfo.IsShowCommuteIntegral = res.IsShowCommuteIntegral
          this.panelItemInfo.IsShowCoupon = res.IsShowCoupon
          Tickets.SetTicket(Tickets.ConvertCouponListModels(this.panelItemInfo.CouponList))
        })
      },
      getDetail () {
        this.vasObj.loadDetail(137).then(res => {
          this.goodsInfo = res.panelItems[0]
        }).catch(e => {
        })
      },
      orderConfirm: debounce(function () {
        if (this.versionId === 0) {
          return
        }
        console.log({goodsId: this.versionId, remark: this.remarkId})
        this.$store.commit('setOrderConfirmConfig', {
          showAddress: this.remarkId !== 0,
          showRemark: false
        })
        // 存储当前物品信息和数量 this.redemptionGroupId
        this.$emit('updateGoodsObj', {goodsId: this.versionId, remark: this.remarkId})
        this.$store.commit('setOrderGoodsInfo', {
          goodsId: this.versionId,
          remark: this.remarkId,
          name: this.goodsInfo.title,
          icon: this.goodsInfo.img,
          price: this.defaultPrice,
          count: this.selectCount,
          isCouponUnAvaliable: !(this.panelItemInfo.CouponList.length > 0 && this.panelItemInfo.IsShowCoupon !== 0),
          isIntegralUnAvaliable: this.panelItemInfo.IsShowCommuteIntegral === 0,
          goodsType: 1
        })
        this.$router.push({path: `/orderConfirm`, params: {goodsId: this.versionId, remark: this.remarkId}})
      }, 220)
    },
    computed: {
      // 计算换购选中值
      redemptionGroupId () {
        // 是否选中短信
        if (this.redemptionObj[0].checked) {
          if (this.redemptionObj[1].checked) {
            return this.redemptionGroup.bothSelected
          }
          return this.redemptionGroup.addMessage
        } else if (this.redemptionObj[1].checked) {
          return this.redemptionGroup.prolong
        }
        return this.redemptionGroup.nullRedemption
      },
      selectedItem () {
        // console.log(this.productItem)
        // let selectdArray = this.productItem.filter(item => {
        //   if (item.checked) return item.name
        // })
        // let redemptionptArray = this.redemptionObj.filter(item => {
        //   if (item.checked) return item.name
        // })
        // let hardwareName = (selectdArray[0] || {}).name || ''
        // let redemptionName = (redemptionptArray[0] || {}).name || ''
        // return `${hardwareName}${redemptionName}`
      }
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?52756784